import { useEffect, useRef } from "react";

export default function useClickOutside(handler, ignoreRef = null) {
  const domNode = useRef();

  useEffect(() => {
    const listener = (event) => {
      if (ignoreRef?.current) {
        ignoreRef.current = false;
        return;
      }
      if (ignoreRef) {
        ignoreRef.current = false;
      }
      if (!domNode.current?.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("click", listener);

    return () => {
      document.removeEventListener("click", listener);
    };
  }, [handler, ignoreRef]);

  return domNode;
}
